import "./sparklineCellRenderer.scss";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { getDateString } from "common/date-utils";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { language } from "language/default";
export const sparklineTooltipRenderer = (params) => {
    const { yValue, xValue } = params;
    const tooltipParams = [];
    tooltipParams.push([language.en.chart.timeBasedSeries.tooltip.referenceDate, getDateString(new Date(xValue))]);
    tooltipParams.push([xValue.label, xValue.tooltipValue || yValue?.toString() || "0"]);
    return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: tooltipParams }));
};
